import { render } from "./AdminDashBoard.vue?vue&type=template&id=8c8412e4"
import script from "./AdminDashBoard.vue?vue&type=script&lang=js"
export * from "./AdminDashBoard.vue?vue&type=script&lang=js"

import "./AdminDashBoard.vue?vue&type=style&index=0&id=8c8412e4&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__